exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-sobre-mi-tsx": () => import("./../../../src/pages/sobre-mi.tsx" /* webpackChunkName: "component---src-pages-sobre-mi-tsx" */),
  "component---src-pages-vuelve-a-ti-tsx": () => import("./../../../src/pages/vuelve-a-ti.tsx" /* webpackChunkName: "component---src-pages-vuelve-a-ti-tsx" */)
}

